import { combineReducers } from "redux";

import sieste from "./modal-enfant/les-tabs-ducks/Sieste.ducks";
import arrivee from "./modal-enfant/les-tabs-ducks/Arrive.ducks";
import absence from "./modal-enfant/les-tabs-ducks/Absence.ducks";
import activite from "./modal-enfant/les-tabs-ducks/Activite.ducks";
import depart from "./modal-enfant/les-tabs-ducks/Depart.ducks";
import message from "./modal-enfant/les-tabs-ducks/Message.ducks";
import petitcoin from "./modal-enfant/les-tabs-ducks/Petitcoin.ducks";
import sante from "./modal-enfant/les-tabs-ducks/Sante.ducks";
import repas from "./modal-enfant/les-tabs-ducks/Repas.ducks";


export const IS_UPDATE_EVENTS = "IS_UPDATE_EVENTS";
export const END_UPDATE_EVENTS = "END_UPDATE_EVENTS";

export const IS_VIEW_EVENTS = "IS_VIEW_EVENTS";
export const END_VIEW_EVENTS = "END_VIEW_EVENTS";

const initialState = {

}

const isUpdateEvents = (state = false, { type }) => {
  switch (type) {

    case IS_UPDATE_EVENTS:
      return true;

    case END_UPDATE_EVENTS:
      return false;

    default:
      return state
  }
}

const isViewEvents = (state = false, { type }) => {
  switch (type) {

    case IS_VIEW_EVENTS:
      return true;

    case END_VIEW_EVENTS:
      return false;

    default:
      return state
  }
}

export const startUpdateEvents = () => ({
  type: IS_UPDATE_EVENTS,
})
export const endUpdateEvents = () => ({
  type: END_UPDATE_EVENTS,
})

export const startViewEvents = () => ({
  type: IS_VIEW_EVENTS,
})
export const endViewEvents = () => ({
  type: END_VIEW_EVENTS,
})


export default combineReducers({
  sieste: sieste,
  arrivee: arrivee,
  absence: absence,
  activite: activite,
  depart: depart,
  message: message,
  petitcoin: petitcoin,
  sante: sante,
  repas: repas,
  isUpdateEvents,
  isViewEvents

});
